// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tabs[data-v-09dd3596], .tab-content.col[data-v-09dd3596] {\n  height: calc(100vh - 65px);\n  overflow: auto;\n}\n.item[data-v-09dd3596] {\n  cursor: pointer;\n  line-height: 1.5;\n}\n.bold[data-v-09dd3596] {\n  font-weight: bold;\n}\nul[data-v-09dd3596] {\n  list-style-type: none;\n}\n.customIndent[data-v-09dd3596] {\n  margin-left: -20px;\n}\n", ""]);
// Exports
module.exports = exports;
